/**
 * @generated SignedSource<<4bc975d2070103fb9753a375d450aeea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExternalProjectMemberForm_viewer$data = {
  readonly account: {
    readonly clients: ReadonlyArray<{
      readonly active: boolean;
      readonly id: number;
      readonly name: string;
    }>;
    readonly id: number;
    readonly people: ReadonlyArray<{
      readonly active: boolean;
      readonly contracts: ReadonlyArray<{
        readonly employment_type: string;
        readonly end_date: string | null | undefined;
        readonly id: number;
        readonly minutes_per_day: number | null | undefined;
        readonly role: {
          readonly id: number;
          readonly name: string;
        };
        readonly start_date: string | null | undefined;
      }>;
      readonly email: string | null | undefined;
      readonly first_name: string;
      readonly id: number;
      readonly is_placeholder: boolean;
      readonly last_name: string;
    }>;
    readonly rate_cards: ReadonlyArray<{
      readonly active: boolean;
      readonly id: number;
      readonly name: string | null | undefined;
    }>;
    readonly roles: ReadonlyArray<{
      readonly id: number;
      readonly name: string;
    }>;
  };
  readonly " $fragmentType": "ExternalProjectMemberForm_viewer";
};
export type ExternalProjectMemberForm_viewer$key = {
  readonly " $data"?: ExternalProjectMemberForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExternalProjectMemberForm_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  (v2/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "peopleFilter"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExternalProjectMemberForm_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "accounts",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "where",
              "variableName": "peopleFilter"
            }
          ],
          "concreteType": "people",
          "kind": "LinkedField",
          "name": "people",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "first_name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "last_name",
              "storageKey": null
            },
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "is_placeholder",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "contracts",
              "kind": "LinkedField",
              "name": "contracts",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employment_type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minutes_per_day",
                  "storageKey": null
                },
                {
                  "alias": "start_date",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "start_date_runn",
                  "storageKey": null
                },
                {
                  "alias": "end_date",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "end_date_runn",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "roles",
                  "kind": "LinkedField",
                  "name": "role",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "roles",
          "kind": "LinkedField",
          "name": "roles",
          "plural": true,
          "selections": (v3/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "rate_cards",
          "kind": "LinkedField",
          "name": "rate_cards",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "clients",
          "kind": "LinkedField",
          "name": "clients",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "users",
  "abstractKey": null
};
})();

(node as any).hash = "729c4a5fd43c3a85dcd2c2fe4590c877";

export default node;
